import { useEffect, useState } from "react";
import { useImx } from "../contexts/ImxContext";
import { handleError } from "../utils/utils";

export default function useCabbage() {
  const { account, localDatabase, assetClient } = useImx();
  const [packedCabbage, setPackedCabbage] = useState(0);
  const [cabbage, setCabbage] = useState(0);

  useEffect(() => {
    const loadPackedCabbage = async () => {
      const packedCabbage = await assetClient.getCabbageAmount(account);
      setPackedCabbage(packedCabbage);
    };

    const loadCabbage = async () => {
      const farmingPlayer = await localDatabase.getFarmingPlayer(account);
      setCabbage(farmingPlayer?.storage?.cabbage || 0);
    };

    const refreshPacked = (e) => {
      if (!e || e.types.includes("cabbage")) {
        loadPackedCabbage().catch(handleError);
      }
    };

    const refresh = (e) => {
      loadCabbage().catch(handleError);
    };

    refreshPacked();
    refresh();
    localDatabase.onAssetsChange(refreshPacked);
    localDatabase.onFarmingPlayerChange(refresh);
    return () => {
      localDatabase.offAssetsChange(refreshPacked);
      localDatabase.offFarmingPlayerChange(refresh);
    };
  }, [account]);

  return {
    cabbage,
    packedCabbage,
  };
}
